import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  articleListeReducer,
  articleFamilleReducer,
  articleDetailsReducer,
  articleSearchReducer,
  evaCreeReducer,
  articleMarqueReducer,
  articleListeAllReducer,
  articleNvCreerReducer,
  articleListePromoReducer,
} from "./reducers/articlesReducers";
import {
  clientLoginReducer,
  clientListeReducer,
  clientCodeReducer,
  clientInscReducer,
  cliServReducer,
} from "./reducers/clientsReducers";

import {
  messageListeReducer,
  messageCreeReducer,
} from "./reducers/messageReducers";

import {
  familleListeReducer,
  familleSearchReducer,
} from "./reducers/familleReducers";
import { marqueSearchReducer } from "./reducers/marqueReducers";

import { chariotAjoutReducer } from "./reducers/chariotReducers";
import {
  creeCommandeReducer,
  commandeMonListeReducer,
  commandeDetailsReducer,
  commandeListeCodeReducer,
  commandeListeRepReducer,
  commandeTousReducer,
  rapportVenteReducer,
} from "./reducers/commandeReducers";
import {
  listeSocietesReducer,
  societeActuelle,
  societeCreerReducer,
  societeUpdateReducer,
  detailsSocieteReducer,
  //variable global de l'application

  //fin variable global de l'application
} from "./reducers/societeReducers";
import {
  paramParCliReducer,
  updateParamReducer,
} from "./reducers/paramAppReducers";
import { listeGroupReducer, creeGroupReducer } from "./reducers/groupReducers";
import {
  caisseConslistReducer,
  caisseConsultReducer,
  caisseSuppReducer,
} from "./reducers/caisseReducers";
import { workAjoutReducer } from "./reducers/work_terminalReducers";
import {
  oraArticleFamilleReducer,
  oraFamilleSearchReducer,
} from "./reducers/oracleReducers";
import {
  chaineGetReducer,
  chaineUpdateReducer,
} from "./reducers/chaineReducers";
import {
  listeRapportsReducer,
  rapportCreerReducer,
} from "./reducers/rapportReducers";
import {
  inscriptionCreeReducer,
  inscriptionListeReducer,
} from "./reducers/inscriptionReducers";
const clientEnreg = localStorage.getItem("client");
const initialState = {};
const reducer = combineReducers({
  groupListe: listeGroupReducer,
  groupCree: creeGroupReducer,
  articleListe: articleListeReducer,
  articleListePromo: articleListePromoReducer,

  client: clientLoginReducer,
  familleSearchListe: familleSearchReducer,
  marqueSearchListe: marqueSearchReducer,
  // const fSearch = useSelector((state) => state.marqueSearchListe);
  msg_distant: messageListeReducer,
  msgCree: messageCreeReducer,

  //const fSearch = useSelector((state) => state.messageSearch);
  articleNvCree: articleNvCreerReducer,
  articleFamille: articleFamilleReducer,
  articleMarque: articleMarqueReducer,
  familleListe: familleListeReducer,
  articleDetails: articleDetailsReducer,
  //chariot est le variable qui contient les information chariotajoutreducer
  chariot: chariotAjoutReducer,
  toutArticle: articleSearchReducer,
  commandeCreer: creeCommandeReducer,
  mesCommandes: commandeMonListeReducer,
  mesParams: paramParCliReducer,
  commandeDetails: commandeDetailsReducer,
  commandesListeCode: commandeListeCodeReducer,
  commandesListeRep: commandeListeRepReducer,
  commandesTousState: commandeTousReducer,

  paramUpdate: updateParamReducer,
  evaCree: evaCreeReducer,
  //le resultat de la fonction clientListeReducer est un objet qui va etre affecte dans le state clientsListeState alore c'est variable qui va etre utiliser dans le composant avec le useSelecter
  clientsListeState: clientListeReducer,
  clientsCodeState: clientCodeReducer,
  clientCree: clientInscReducer,
  //le resultat de la fonction listeSocietesReducer est un objet qui va etre affecte dans le state listeSocietes alore c'est variable qui va etre utiliser dans le composant avec le useSelecter
  //finalement le resultat de la fonction listeSocietesReducer sera affecter dans le variable listeSocietes dans le state
  listeSocietes: listeSocietesReducer,
  //-----------------------------------------------------------------------------
  societeActuelle: societeActuelle,
  societeCreer: societeCreerReducer,
  societeUpdate: societeUpdateReducer,
  societeDetails: detailsSocieteReducer,
  caisseConsult: caisseConsultReducer,
  workListeState: workAjoutReducer,
  articlesAll: articleListeAllReducer,
  oraFamilleRech: oraFamilleSearchReducer,
  oraArticleFamille: oraArticleFamilleReducer,
  chaineGetState: chaineGetReducer,
  chaineUpdateState: chaineUpdateReducer,
  caisseConslistState: caisseConslistReducer,
  caisseSuppState: caisseSuppReducer,
  cliServState: cliServReducer,
  rapportListe: listeRapportsReducer,
  rapportCreer: rapportCreerReducer,

  inscCree: inscriptionCreeReducer,
  inscListe: inscriptionListeReducer,
  rapportVntState: rapportVenteReducer,
});
const middleware = [thunk];

export const store = createStore(
  reducer,

  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
